import { render, staticRenderFns } from "./waitauditaftersaledetail.vue?vue&type=template&id=6fb4398c&"
import script from "./waitauditaftersaledetail.vue?vue&type=script&lang=js&"
export * from "./waitauditaftersaledetail.vue?vue&type=script&lang=js&"
import style0 from "./waitauditaftersaledetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports